module.exports = __webpack_public_path__ + "assets/img/yjsfw.08696e4b.png";